<template>
	<div>
		<el-dialog
			:visible.sync="submitDialog"
			width="30%"
			:title="confirmationTitle"
			class="header hide-overflow"
			:before-close="cancel"
		>
			<span>{{ confirmationText }}</span>
			<div>
				<el-row :gutter="10">
					<el-col :span="6" :offset="11">
						<el-button
							class="button-class-white2"
							style="border: none; margin-top: 40px"
							@click="cancel"
							:loading="loading"
							>Later</el-button
						>
					</el-col>
					<el-col :span="6">
						<el-button
							:loading="loading"
							:style="loading ? 'margin-top:30px' : ''"
							class="button-class"
							@click="success"
							>Confirm</el-button
						>
					</el-col>
					<el-col :span="1"> </el-col>
				</el-row>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	props: {
		submitDialog: Boolean,
		confirmationTitle: String,
		confirmationText: String,
		loading: Boolean,
        actionObject:Object,
        alertType:String,
	},
	methods: {
		cancel() {
			this.$emit("cancel",this.alertType);
		},
		success() {
			this.$emit("success",this.actionObject );
		},
	},
};
</script>

<style>
.hide-overflow {
	overflow: hidden;
	overflow-y: hidden;
	overflow-x: hidden;
}
.el-dialog__body {
	overflow: hidden !important;
	overflow-y: hidden;
	overflow-x: hidden;
}
</style>
